module.exports = __webpack_public_path__ + "media/notification.199dce56.mp3";